'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createElement = createElement;
function createElement(name) {
    return document.createElementNS('http://www.w3.org/2000/svg', name);
}

exports.default = {
    createElement: createElement
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_marks-pane@1.0.9@marks-pane/lib/svg.js
// module id = JmG7
// module chunks = 0